var map = {
	"./footer-logo.svg": "./src/assets/img/svg/footer-logo.svg",
	"./h-01.svg": "./src/assets/img/svg/h-01.svg",
	"./h-02.svg": "./src/assets/img/svg/h-02.svg",
	"./h-03.svg": "./src/assets/img/svg/h-03.svg",
	"./h-04.svg": "./src/assets/img/svg/h-04.svg",
	"./hamburger-close.svg": "./src/assets/img/svg/hamburger-close.svg",
	"./hamburger-open.svg": "./src/assets/img/svg/hamburger-open.svg",
	"./input-file.svg": "./src/assets/img/svg/input-file.svg",
	"./logo.svg": "./src/assets/img/svg/logo.svg",
	"./modal-close.svg": "./src/assets/img/svg/modal-close.svg",
	"./modal-result.svg": "./src/assets/img/svg/modal-result.svg",
	"./social-01.svg": "./src/assets/img/svg/social-01.svg",
	"./social-02.svg": "./src/assets/img/svg/social-02.svg",
	"./social-03.svg": "./src/assets/img/svg/social-03.svg",
	"./social-04.svg": "./src/assets/img/svg/social-04.svg",
	"./social-05.svg": "./src/assets/img/svg/social-05.svg",
	"./text-look.svg": "./src/assets/img/svg/text-look.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/svg sync recursive \\.svg$";